<script>
import _ from 'lodash';
import AssessmentScore from './AssessmentScore.vue';

export default {
  name: 'Assessments',
  props: {
    scores: {
      type: Array,
      required: false
    },
    noDataMsg: {
      type: String,
      required: true
    }
  },
  components: {
    AssessmentScore
  },
  computed: {
    filteredScores: function() {
      if (!this.scores) {
        return [];
      }
      // group and filter the scores
      let filteredScores = [];
      this.scores.forEach(function(item) {
        let thisTitle = getTitle(item);
        if (thisTitle) {
          let assessment = _.find(filteredScores, { title: thisTitle });
          if (assessment) {
            assessment.results.push(item);
          } else {
            filteredScores.push({ 'title': thisTitle, 'results': [ item ] });
          }
        }
      });

      return filteredScores;
    }
  },
  // Using render instead of template because dd is same level as dt
  render(createElement) {
    if (this.filteredScores.length > 0) {
      return createElement('dl', this.filteredScores.map(function(item) {
        return [
          createElement('dt', item.title),
          createElement('dd', [
            createElement(AssessmentScore, {
              props: {
                results: item.results
              }
            })
          ])
        ];
      }));
    } else {
      return createElement('dl', [
        createElement('dt', 'Assessment Scores'),
        createElement('dd', this.noDataMsg)
      ]);
    }
  }
};

function getTitle(score) {
  if (score.assessmentName.toLowerCase() === 'dass21' && score.categoryName === 'Anxiety') {
    return 'DASS-Anxiety';
  }
  if (score.assessmentName.toLowerCase() === 'dass21' && score.categoryName === 'Depression') {
    return 'DASS-Depression';
  }
  if (score.assessmentName.toLowerCase() === 'phq9') {
    return 'PHQ-9';
  }
  if (score.assessmentName.toLowerCase() === 'gad7') {
    return 'GAD-7';
  }
  if (score.assessmentName.toLowerCase() === 'who-5') {
    return 'WHO-5';
  }
  // other assessmentTypes are not displayed
  return null;
}
</script>